import { MetaT } from '@global/types';

export default {
    title: 'Регистрация для самозанятых курьеров | CRM LIVECARGO',
    description:
        'Присоединяйтесь к платформе LIVECARGO и регистрируйтесь в CRM-системе как самозанятый, чтобы находить заказы из сферы логистики',
} as MetaT;
